import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    IAlert,
    IAlertsError,
    ICreateAlertPayload,
    IDeleteAlertPayload,
    ITriggeredAlertPayload,
    IUpdateAlertPayload
} from "./alerts.t";

export interface IAlertsState {
    alertsList: IAlert[],
    alertsListError: IAlertsError,
    isAlertDeleteLoading: boolean,
    isAlertsListLoading: boolean,
    isInited: boolean,
}

const initialState: IAlertsState = {
    isInited: false,

    alertsList: [],
    alertsListError: null,
    isAlertsListLoading: false,

    isAlertDeleteLoading: false,
}

export const alertsSlice = createSlice({
    name: 'alerts',
    initialState,
    reducers: {
        initAlertsAction(state, action: PayloadAction) {},
        setIsAlertsInitedAction(state, action: PayloadAction<boolean>) {
            state.isInited = action.payload;
        },

        loadAlertsListAction(state, action: PayloadAction) {
            state.isAlertsListLoading = true;
        },
        loadAlertsListSuccess(state, action: PayloadAction<IAlert[]>) {
            state.alertsList = action.payload;
            state.isAlertsListLoading = false;
        },
        loadAlertsListFailure(state, action: PayloadAction<IAlertsError>) {
            state.isAlertsListLoading = false;
            state.alertsListError = action.payload;
        },

        deleteAlertAction(state, action: PayloadAction<IDeleteAlertPayload>) {
            state.isAlertDeleteLoading = true;
        },
        deleteAlertSuccess(state, action: PayloadAction<IDeleteAlertPayload>) {
            state.isAlertDeleteLoading = false;
            state.alertsList = state.alertsList.filter(alert => alert.id !== action.payload);
        },
        deleteAlertFailure(state, action: PayloadAction<IAlertsError>) {
            state.isAlertDeleteLoading = false;
        },

        createAlertAction(state, action: PayloadAction<ICreateAlertPayload>) {},
        createAlertSuccess(state, action: PayloadAction<IAlert>) {
            state.alertsList.push(action.payload);
        },
        createAlertFailure(state, action: PayloadAction) {},

        updateAlertAction(state, action: PayloadAction<IUpdateAlertPayload>) {},
        updateAlertSuccess(state, action: PayloadAction<IUpdateAlertPayload>) {
            state.alertsList = state.alertsList.map(alert =>
                alert.id === action.payload.id ? { ...alert, ...action.payload } : alert
            );
        },
        updateAlertFailure(state, action: PayloadAction<IAlertsError>) {},

        handleTriggeredAlertAction(state, action: PayloadAction<ITriggeredAlertPayload>) {
            state.alertsList = state.alertsList.filter(alert => alert.id !== action.payload.id);
        },
    }
});

export default alertsSlice.reducer;
